const modalDE = {
    selection: 'Auswahlmöglichkeiten',
    addList: 'Zur Liste hinzufügen',
    addCart: 'In den Warenkorb',
    openCatalog: 'Im Katalog öffnen'
}

export default modalDE
